import { IQualifier } from "../../model/formconfiguration/Qualifier";
import { IQualiferService } from "../../service/formconfiguration/QualifierService";

export default class UpdateQualifierInteractor {
  private qualifierService: IQualiferService;

  constructor(qualifierService) {
    this.qualifierService = qualifierService;
  }

  async execute(qualifierCode: string, qualifier: IQualifier) {
    await this.qualifierService.updateQualifier(qualifierCode, qualifier);
  }
}
